import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types';

import { getQuotesTotalScore, getQuotes } from '../selectors/quote-selector';

const ListsImpl = (props) => (
    <React.Fragment>
          <ul>
              {
              props.quotes.map( (quoteList, index )=> (
                <React.Fragment key={index}>
                    <h2 key={index}><strong>{quoteList.type} quotes</strong></h2>
                    <ul qa-id={quoteList.type}>
                    {
                        quoteList.quotes.map( (element, index) => (
                        <li key={index}><span>{element.quote}</span> (<span className="score">{element.score}</span>)</li>
                        ))
                    }
                    </ul>
                </React.Fragment>
              ))}
          </ul>
          <div id="summary">
              Total score: {props.totalScore}
          </div>
    </React.Fragment>
  )
const mapStateToProps = state => ({
    quotes: getQuotes(state),
    totalScore: getQuotesTotalScore(state)
});

ListsImpl.propTypes = {
    quotes: PropTypes.arrayOf(
        PropTypes.shape( {
            type: PropTypes.string,
            quotes: PropTypes.arrayOf(
                PropTypes.shape( {
                    quote: PropTypes.string,
                    score: PropTypes.number
                }
            )),
        })
    ).isRequired,
    totalScore: PropTypes.number
};

export const Lists = connect(mapStateToProps)(ListsImpl);
